<template>
	<div>
		<el-dialog class="close-private cps-dialog-icon-line-height"
			:visible.sync="visible"
			:title="$t('listPage.text.delete')"
			:close-on-click-modal="false"
			:before-close="handleClose">
			<div class="i-text">
				<div class="tip-warning mb20 lh20"
					v-html="$t('listPage.speechCraft.deleteInstanceTip')">
				</div>
			</div>
			<div class="reinstall-tip">
				{{$t('listPage.speechCraft.deleteInstanceChecnkWarning', [rowInfo.name])}}
			</div>
			<input type="checkbox" v-model="sureDelete" id="sureCharge"/>
			<label for="sureCharge">{{ $t('listPage.speechCraft.sureCharge') }}</label>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelDel">{{ $t('privateNetInstance.cancel') }}</el-button>
				<el-button @click="sureDel" type="primary"
					:disabled="!sureDelete">
					{{ $t('privateNetInstance.sure') }}
				</el-button>
			</div>
		</el-dialog>
		<jcb-opt-protect 
			:visible.sync="operationProtectVisible" 
			:action-type="OperationConstant.DELETE"
			@success="onSuccess" @error="onError">
		</jcb-opt-protect>
	</div>
</template>

<script>
import operationProtect from '@/mixins/operationProject';
import { OperationConstant } from '@/common/Constants';

export default {
	name: 'DeleteInstance',
	mixins: [operationProtect],

	props: {
		visible: {
			type: Boolean,
			default: false
		},
		rowInfo: {
			type: Object,
			default: () => {}
		},
		pageSource: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			// 是否勾选了确认的checkbox
			sureDelete: false,
			// 操作保护弹框是否显示
			operationProtectVisible: false,
		};
	},
	computed: {
		OperationConstant: () => OperationConstant
	},
	methods: {
		handleClose() {
			this.sureDelete = false;
			this.$emit('update:visible', false);
		},
		/**
		 * 取消删除操作
		 */
		cancelDel() {
			this.handleClose();
		},
		/**
		 * 确定删除打开操作保护
		 */
		sureDel() {
			this.openOperationProtect(OperationConstant.DELETE, this.rowInfo, this.pageSource);
			this.handleClose();
		},
		/**
		 * 删除物理机
		 * @param headers
		 */
		deleteInstance(headers) {
			const params = {
				instanceId: this.rowInfo.instanceId,
				region: this.rowInfo.region,
				clientToken: this.clientToken
			};
			Ajax.post('/api/cps/deleteInstance', params, { headers }).then(() => {
				if (this.pageSource === 'list') {
					this.$emit('refresh');
				} else {
					this.$emit('goList');
				}
			}).finally(() => {
				this.handleClose();
			});
		},
	},

};
</script>

<style lang="scss">
	.close-private{
		.reinstall-confirm-checkbox{
			margin-top: 30px;
			margin-bottom: -20px;
			.jc-checkbox__label{
				color:rgb(121, 121, 121)
			}
		}
		.reinstall-tip {
			width:100%;
			font-size:15px;
			color:#797979;
			word-break: break-word;
			padding-bottom: 5px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/common/DeleteInstance.vue